var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("address", [
    _vm._v(" " + _vm._s(_vm.address.addressLine)),
    _c("br"),
    _vm._v(" " + _vm._s(_vm.address.city)),
    _c("br"),
    _vm._v(" " + _vm._s(_vm.address.postalCode) + " "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }